/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable func-names */
/* eslint-disable import/extensions */
import '~/assets/js/global.js';
import dayjs from 'dayjs';
// eslint-disable-next-line no-unused-vars
import { getBranding } from '~/assets/js/utils/whitelabeling.js';
import demoScanId from '~/assets/constants/demo_scan_id.js';
import NavbarMain from '~/components/shared/navbar-main.vue';
import Modal from '~/components/shared/templates/modal.vue';
import ModalsCancelDelete from '~/components/shared/modals-cancel-delete.vue';
import ModalsJira from '~/components/shared/modals-jira.vue';
import ModalsHome from '~/components/home/modals-home.vue';
import PageHeader from '~/components/dashboard/components/page-header.vue';
import _ from 'lodash';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faChevronCircleDown, faChevronCircleRight, faFileDownload, faTrash, faRedo, faTimesCircle, faEye,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faChevronCircleDown);
library.add(faChevronCircleRight);
library.add(faFileDownload);
library.add(faTrash);
library.add(faRedo);
library.add(faTimesCircle);
library.add(faEye);


export default {
    // el: '#app',
    components: {
        NavbarMain, Modal, ModalsCancelDelete, ModalsHome, ModalsJira, PageHeader, FontAwesomeIcon,
    },
    data() {
        return {
            timestamp: 0,
            labels: null,
            scans: null,
            selectedScan: null,
            modalState: {
                delete: false,
                cancel: false,
                first: false,
                jira_report: false,
                jira_return_success: false,
            },
            placeholder: true,
            risk_reports: null,
            risk_reports_page_url: '/risk-report?risk_report_id=',
            hasAccessToJira: false,
            isLoading:false,
            focusedScanIndex:null,
            breadcrumbsLinks: [
                {
                    text: 'Dashboard',
                    onClick: () => {
                        this.goToDashboard();
                    },
                },
            ],
            verifiedAccount: false,
            integrationLogoPath: {
                qualys: '/assets/images/qualys-logo-24.png',
                nessus: '/assets/images/nessus-logo-24.png',
                rapid7: '/assets/images/rapid7-icon.png',
            },
        };
    },
    created() {
        this.checkAccountVerified();
    },
    mounted() {
        this.$el.className = '';
        if (window.location.hash.includes('first')) {
            this.updateModal({
                key: 'first',
                state: true,
            });
        }
        this.doBackendRequest(
            'GET',
            '/api/has_access_to_jira',
            (response) => {
                this.hasAccessToJira = response.has_access_to_jira;
            },
            undefined,
            undefined,
        );
    },
    filters: {
        dateStarted(unixstamp) {
            return dayjs.unix(unixstamp).format('ddd, D MMM YYYY');
        },
        dateFinish(values) {
            if (values[3]) {
                return dayjs.unix(values[3]).format('ddd, D MMM YYYY');
            } else {
                const started = values[0];
                const currentTime = values[1];
                const progress = values[2];
                const elapsed = currentTime - started;
                const estimatedFinish = (started + (elapsed / progress));
                const mins = Math.round((estimatedFinish - currentTime) / 60);
                let remain = '';
                if (progress < 0.001) {
                    return 'Starting up';
                }else if (progress === 1) {
                    remain = 'Generating Report';
                } else if (mins < 1) {
                    remain = 'Finishing up';
                } else if (mins < 60) {
                    remain = `${mins} mins to go`;
                } else {
                    remain = `${Math.round(mins / 60)} hrs to go`;
                }
                return remain;
            }
        },
        niceStarted(unixstamp) {
            const nicedate = dayjs.unix(unixstamp).format('HH:mm on MMM D, YYYY');
            return `Scan started at ${nicedate}`;
        },
        timeRemaining(values) {
            const progress = values[2];
            if (progress < 0.001) {
                return 'Starting up';
            }
            const started = values[0];
            const currentTime = values[1];
            const elapsed = currentTime - started;
            const estimatedFinish = (started + (elapsed / progress));
            const mins = Math.round((estimatedFinish - currentTime) / 60);
            let remain = '';
            if (progress === 1) {
                remain = 'Generating Report';
            } else if (mins < 1) {
                remain = 'Finishing up';
            } else if (mins < 60) {
                remain = `${mins} mins to go`;
            } else {
                remain = `${Math.round(mins / 60)} hrs to go`;
            }
            return remain;
        },
        percentDone(value) {
            const percent = Math.floor(value * 100);
            return percent;
        },
    },
    methods: {
        checkAccountVerified() {
            this.doBackendRequest(
                'GET',
                `/api/check_verified_account`,
                (response) => {
                    if (response.verified) {
                        this.verifiedAccount = true;
                        this.getScans();
                    } else {
                        this.verifiedAccount = false;
                        this.updateModal({ key: 'unverified', state: true, message: "" });
                    }
                },
                undefined,
                () => {},
            )
        },
        checkIfDemoScan(scanId) {
            if (demoScanId.includes(scanId)) {
                return true;
            }
            return false;
        },
        goToLink(link) {
            window.location.href = link;
        },
        getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
            const results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2]);
        },
        getUrl() {
            const url = window.location.search
            if(url) {
                const email = this.getParameterByName('email')
                const replacedEmail = email.replace(/\+/g, '%2B')
                return url.replace(email, replacedEmail)
            }
            return ''
        },
        getScans() {
            const self = this;
            this.isLoading = true;
            const url = this.getUrl();
            this.doBackendRequest('GET', `/api/scans${url}`, (responseJson) => {
                self.scans = responseJson.result.scan_label;
                self.timestamp = responseJson.timestamp;
                this.isLoading = false;
            }, undefined, undefined);
            this.doBackendRequest('GET', '/api/risk_reports', (responseJson) => {
                if (responseJson.length) { self.risk_reports = responseJson; }
            }, undefined, undefined);
        },
        // eslint-disable-next-line object-shorthand
        toggle: function (e) {
            e.preventDefault();
            alert('Toggle the stuffs');
        },
        // eslint-disable-next-line object-shorthand
        downloadScan: function (e) {
            e.preventDefault();
            alert('Download time');
        },
        emailScan() {
            console.log(`emailScan scan_id: ${this.showModalEmail}`);
            alert('TODO: email time');
        },
        cancelScan(scanId) {
            const self = this;
            this.doBackendRequest(
                'POST',
                `/api/cancel_scan?scan_id=${scanId}`,
                () => {
                    self.getScans();
                },
                undefined,
                undefined,
            );
        },
        deleteScan(scanId) {
            const self = this;
            this.doBackendRequest(
                'POST',
                `/api/delete_scan?scan_id=${scanId}`,
                () => {
                    self.getScans();
                },
                undefined,
                undefined,
            );
        },
        prompt(scanId, method) {
            this.selectedScan = scanId;
            this.updateModal({
                key: method,
                state: true,
            });
        },
        async downloadReport(scanId) {
            try {
                await this.doBackendRequestAsync('GET', '/api/is_logged_in');
            } catch (e) {
                return;
            }
            window.location = `/downloads/xlsx?scan_id=${scanId}`;
        },
        canceledScanInfo(scan) {
            if (scan.canceled_from_jira) {
                return 'Cancelled from Jira';
            }
            return `Cancelled by ${scan.canceled_by_email}`;
        },
        convertOpochToDate(unixdate) {
            try {
                if (unixdate) {
                    const date = dayjs.utc(unixdate * 1000).format('DD-MMM-YYYY');
                    return (date === 'Invalid Date') ? unixdate : date;
                }
            } catch (err) {
                return null;
            }
            return null;
        },
        capitalizeWord(word) {
            return _.capitalize(word);
        },
        integrationScanInfo(integration) {
            return `This scan includes ${this.capitalizeWord(integration)} scan results`;
        },
        setFocusedScanIndex(index) {
            this.focusedScanIndex = index
        },
        goToDashboard() {
            window.location.href = window.location.origin + '/home';
        },
        setBreakWord(label) {
            if (!(/\s/).test(label) && label.length >= 23 && window.innerWidth <= 1024) {
                return "break-word";
            };
        },
    },
};
